import createInvoice from '../../api/createInvoice';

export default async function getGuideInvoice(bookingInfo, onSuccess) {
  const { trekName, id, startDate, endDate, pax } = bookingInfo; 
  try {
    const data = {
      leadersOnly: {
        trekName,
        leaderId: id,
        startDate,
        endDate,
        numTrekkers: Number(pax),
      }
    };

    const { invoices } = await createInvoice(data);
    const invoice = invoices[0];

    onSuccess(invoice);

  } catch (e) {
    console.log(e);
  }
}